import React from 'react';
import { Modal, Form, Select, DatePicker, Button, Space, Switch, Grid, Row, Col, Flex, Typography } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { useBreakpoint } = Grid;
const { Text } = Typography;

const AdvancedFilters = ({
    handleCancel,
    onApply,
    initialValues
}) => {
    const [form] = Form.useForm();
    const screens = useBreakpoint();
    const { isDarkMode } = useTheme();
    const { t } = useTranslation();

    const themeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)',
        border: isDarkMode ? '#434343' : '#d9d9d9',
        modalShadow: isDarkMode ? '0 4px 16px rgba(0, 0, 0, 0.5)' : '0 4px 16px rgba(0, 0, 0, 0.1)',
        buttonPrimaryBg: isDarkMode ? '#1890ff' : '#4096ff',
        buttonPrimaryHoverBg: isDarkMode ? '#40a9ff' : '#69c0ff',
    };

    const handleApply = () => {
        form.validateFields()
            .then(values => {
                onApply(values);
                handleCancel();
            });
    };
    return (
        <Modal
            title={<><FilterOutlined style={{ color: themeColors.text }} /> {t('advanced_filters')}</>}
            open
            onCancel={handleCancel}
            width={screens.xs ? "100%" : "720px"}
            style={{
                top: 20, // Adjust modal position
            }}
            bodyStyle={{
                background: themeColors.background,
            }}
            wrapClassName={isDarkMode ? 'dark-mode-modal' : 'light-mode-modal'} // Add class to the modal
            footer={
                <Space>
                    <Button onClick={handleCancel}>{t('cancel')}</Button>
                    <Button type="primary" onClick={handleApply} style={{
                        backgroundColor: themeColors.buttonPrimaryBg,
                        ':hover': {
                            backgroundColor: themeColors.buttonPrimaryHoverBg
                        }
                    }}>{t('apply')}</Button>
                </Space>
            }
            className={isDarkMode ? 'dark-mode-modal' : 'light-mode-modal'}
        >
            <Form form={form} initialValues={initialValues} layout="vertical"
            >
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                        <Form.Item
                            name="dateRange"
                            label={<Text style={{ color: themeColors.text }}>{t('date')}</Text>}
                            style={{ marginBottom: 4 }}
                        >
                            <RangePicker showTime style={{
                                backgroundColor: themeColors.background,
                                borderColor: themeColors.border,
                                color: themeColors.text
                            }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item
                            name="contact_type"
                            label={<Text style={{ color: themeColors.text }}>{t('contact_type')}</Text>}
                        >
                            <Select
                                allowClear
                                style={{
                                    backgroundColor: themeColors.background,
                                    borderColor: themeColors.border,
                                    color: themeColors.text
                                }}
                                dropdownStyle={{
                                    backgroundColor: themeColors.background,
                                    color: themeColors.text
                                }}
                            >
                                <Option value="admin" style={{ color: themeColors.text }}>{t('admin')}</Option>
                                <Option value="customer" style={{ color: themeColors.text }}>{t('customer')}</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Flex gap={screens.xs ? 8 : 16} style={{ color: themeColors.text }}>
                            <Space direction="horizontal" align='center'>
                                <Text style={{ color: themeColors.text }}>{t('ignored')}</Text>
                                <Form.Item name="is_ignored" label="" style={{ marginBottom: 0 }}>
                                    <Switch />
                                </Form.Item>
                            </Space>

                            <Space direction="horizontal">
                                <Text style={{ color: themeColors.text }}>{t('snoozed')}</Text>
                                <Form.Item
                                    name="is_snoozed"
                                    label=""
                                    style={{ marginBottom: 0 }}
                                >
                                    <Switch />
                                </Form.Item>
                            </Space>
                        </Flex>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default AdvancedFilters;
